import { toast } from "react-toastify";
export const successToast = (message) => {
  toast.success(message);
};
export const errorToast = (message) => {
  toast.error(message);
};
export const warningToast = (message) => {
  toast.warning(message);
};
export const infoToast = (message) => {
  toast.info(message);
};
export const loadingToast = (message) => {
  return toast.loading(message);
};
export const updateToastSuccess = (toastId,message
) => {
  toast.update(toastId, {
    render: message,
    type: "success",
    isLoading: false,
    autoClose: 3000,
  });
};

// UPDATE TO ERROR
export const updateToastError = (
  toastId,
  message
) => {

  toast.update(toastId, {

    render: message,

    type: "error",

    isLoading: false,

    autoClose: 3000,
  });
};